import {
  BackendErrorWithMessageError,
  HandledErrorResponse,
  type HandleIdentifiedErrorFn,
} from '@pct-ng/core/error-http';
import { openOKDialog } from '@pct-ng/feature-message-material';
import { map, of } from 'rxjs';

const translations: Record<string, { TITLE: string; MESSAGE: string }> = {
  ACCEPTED_WORKSHOP_ATTENDANCE_CAN_NOT_BE_DELETED: {
    TITLE: 'Hiba',
    MESSAGE:
      'A felhasználó jelentkezése egy vagy több kerekasztal-beszélgetésre elfogadott, ezért nem lehet törölni.',
  },
  AUTH_ERROR: {
    TITLE: 'Hiba',
    MESSAGE: 'Hiba történt a hitelesítés során.',
  },
  FILE_ALREADY_REFERENCED: {
    TITLE: 'Hiba',
    MESSAGE: 'A fájlra már hivatkoznak.',
  },
  INVALID_PHONE_NUMBER: {
    TITLE: 'Hiba',
    MESSAGE: 'A telefonszám érvénytelen.',
  },
  INVALID_REGISTRATION_STATUS: {
    TITLE: 'Hiba',
    MESSAGE: 'Az elfogadott vagy elutasított státusz nem módosítható.',
  },
  NOT_ACCEPTED_REGISTRATION: {
    TITLE: 'Hiba',
    MESSAGE: 'A felhasználó regisztrációja még nincs elfogadva.',
  },
  NOT_FOUND_AUTH0_USER: {
    TITLE: 'Hiba',
    MESSAGE: 'A felhasználónak nincs Auth0 fiókja.',
  },
  NOT_FOUND_PHOTO: {
    TITLE: 'Hiba',
    MESSAGE: 'A fotó nem található.',
  },
  NOT_FOUND_PROGRAM: {
    TITLE: 'Hiba',
    MESSAGE: 'A program nem található.',
  },
  OUT_OF_RANGE_COMPANY_NAME_LENGTH: {
    TITLE: 'Hiba',
    MESSAGE: 'A cégnév hossza tartományon kívül esik.',
  },
  OUT_OF_RANGE_EMAIL_LENGTH: {
    TITLE: 'Hiba',
    MESSAGE: 'Az e-mail cím hossza tartományon kívül esik.',
  },
  OUT_OF_RANGE_PAGE_NUMBER: {
    TITLE: 'Hiba',
    MESSAGE: 'Az oldalszám tartományon kívül esik.',
  },
  OUT_OF_RANGE_PAGE_SIZE: {
    TITLE: 'Hiba',
    MESSAGE: 'Az oldalméret tartományon kívül esik.',
  },
  OUT_OF_RANGE_PHONE_LENGTH: {
    TITLE: 'Hiba',
    MESSAGE: 'A telefon hossza tartományon kívül esik.',
  },
  OUT_OF_RANGE_PHONE_NUMBER_LENGTH: {
    TITLE: 'Hiba',
    MESSAGE: 'A telefonszám hossza tartományon kívül esik.',
  },
  OUT_OF_RANGE_POSITION_LENGTH: {
    TITLE: 'Hiba',
    MESSAGE: 'A beosztás hossza tartományon kívül esik.',
  },
  OUT_OF_RANGE_PROGRAM_DESCRIPTION: {
    TITLE: 'Hiba',
    MESSAGE: 'A leírás hossza tartományon kívül esik.',
  },
  OUT_OF_RANGE_PROGRAM_NAME_LENGTH: {
    TITLE: 'Hiba',
    MESSAGE: 'A név hossza tartományon kívül esik.',
  },
  OUT_OF_RANGE_USER_NAME_LENGTH: {
    TITLE: 'Hiba',
    MESSAGE: 'A név hossza tartományon kívül esik.',
  },
  OUT_OF_RANGE_WEBSITE_LENGTH: {
    TITLE: 'Hiba',
    MESSAGE: 'A weboldal hossza tartományon kívül esik.',
  },
  PASSWORDS_MISMATCH: {
    TITLE: 'Hiba',
    MESSAGE: 'A jelszavak nem egyeznek.',
  },
  REQUIRED_AUDITOR_NAME: {
    TITLE: 'Hiba',
    MESSAGE: 'Az előadó neve kötelező.',
  },
  REQUIRED_COMPANY_NAME: {
    TITLE: 'Hiba',
    MESSAGE: 'A cégnév kötelező.',
  },
  REQUIRED_CONFIRM_PASSWORD: {
    TITLE: 'Hiba',
    MESSAGE: 'A jelszó megerősítése kötelező.',
  },
  REQUIRED_DINNER_ATTENDANCE: {
    TITLE: 'Hiba',
    MESSAGE: 'A vacsorán való részvételt ki kell választani.',
  },
  REQUIRED_EMAIL: {
    TITLE: 'Hiba',
    MESSAGE: 'Az e-mail cím kötelező.',
  },
  REQUIRED_FILE: {
    TITLE: 'Hiba',
    MESSAGE: 'A fájl kötelező.',
  },
  REQUIRED_PASSWORD: {
    TITLE: 'Hiba',
    MESSAGE: 'A jelszó kötelező.',
  },
  REQUIRED_PHONE_NUMBER: {
    TITLE: 'Hiba',
    MESSAGE: 'A telefonszám kötelező.',
  },
  REQUIRED_POSITION: {
    TITLE: 'Hiba',
    MESSAGE: 'A beosztás kötelező.',
  },
  REQUIRED_PROGRAM_NAME: {
    TITLE: 'Hiba',
    MESSAGE: 'A név kötelező.',
  },
  REQUIRED_TERMS_OF_SERVICES: {
    TITLE: 'Hiba',
    MESSAGE: 'A szolgáltatási feltételek elfogadása kötelező.',
  },
  REQUIRED_USER_NAME: {
    TITLE: 'Hiba',
    MESSAGE: 'A név kötelező.',
  },
  REQUIRED_WEBSITE: {
    TITLE: 'Hiba',
    MESSAGE: 'A weboldal kötelező.',
  },
  SUPERADMIN_CANT_DELETE_ITSELF: {
    TITLE: 'Hiba',
    MESSAGE: 'A superadmin nem törölheti önmagát.',
  },
  TAKEN_EMAIL: {
    TITLE: 'Hiba',
    MESSAGE:
      'A megadott e-mail címmel nem sikerült fiókot létrehozni, kérjük lépjen kapcsolatba az informacio@szebit.hu címen ügyfélszolgálatunkkal, vagy próbáljon regisztrálni egy másik e-mail címmel.',
  },
  TOO_LARGE_FILE_SIZE: {
    TITLE: 'Hiba',
    MESSAGE: 'A fájl túl nagy.',
  },
  TOO_LONG_AUDITOR_DESCRIPTION: {
    TITLE: 'Hiba',
    MESSAGE: 'Az előadó leírása túl hosszú.',
  },
  TOO_LONG_AUDITOR_NAME: {
    TITLE: 'Hiba',
    MESSAGE: 'Az előadó neve túl hosszú.',
  },
  USER_ROLE_NOT_OWNED: {
    TITLE: 'Hiba',
    MESSAGE:
      'A bejelentkezett felhasználónak nincs megfelelő jogosultsága a művelet végrehajtásához.',
  },
  INVALID_EMAIL: {
    TITLE: 'Hiba',
    MESSAGE: 'Az e-mail cím formátuma érvénytelen.',
  },
  INVALID_PASSWORD: {
    TITLE: 'Hiba',
    MESSAGE: 'A jelszó érvénytelen.',
  },
  TOO_LONG_EMAIL: {
    TITLE: 'Hiba',
    MESSAGE: 'Az e-mail cím túl hosszú.',
  },
  NOT_FOUND_USER: {
    TITLE: 'Hiba',
    MESSAGE: 'A felhasználó nem található.',
  },
  NOT_FOUND_AUDITOR: {
    TITLE: 'Hiba',
    MESSAGE: 'Az előadó nem található.',
  },

  CANT_DOWNLOAD_FILE: {
    TITLE: 'Hiba',
    MESSAGE: 'A fájl nem tölthető le.',
  },
  NOT_FOUND_FILE: {
    TITLE: 'Hiba',
    MESSAGE: 'A fájl nem található.',
  },
  CANT_STORE_FILE: {
    TITLE: 'Hiba',
    MESSAGE: 'A fájl nem tárolható.',
  },
  FORBID_FILE_CONTENT_TYPE: {
    TITLE: 'Hiba',
    MESSAGE: 'A fájl típusa nem engedélyezett.',
  },
  AUTH_EMAIL_INVALID: {
    TITLE: 'Hiba',
    MESSAGE: 'Érvénytelen e-mail cím.',
  },
  CANT_DELETE_STAND: {
    TITLE: 'Hiba',
    MESSAGE: 'A standnak vannak játékosai, ezért nem törölhető.',
  },
  INACTIVE_STAND: {
    TITLE: 'Hiba',
    MESSAGE: 'Inaktív kiállítói stand nem módosítható.',
  },
  INVALID_ANSWER_COUNT: {
    TITLE: 'Hiba',
    MESSAGE: 'Pontosan 3 választ kell megadni.',
  },
  INVALID_DATES: {
    TITLE: 'Hiba',
    MESSAGE: 'A kezdési időnek korábbinak kell lennie a befejezésnél.',
  },
  INVALID_NOTIFICATION_STATUS: {
    TITLE: 'Hiba',
    MESSAGE: 'A közzétett értesítés nem módosítható vagy törölhető.',
  },
  INVALID_SCHEDULE_DATETIME: {
    TITLE: 'Hiba',
    MESSAGE: 'Az ütemezett dátum és idő a jelenben vagy jövőben kell legyen.',
  },
  INVALID_WORKSHOP_APPLICATION_STATUS: {
    TITLE: 'Hiba',
    MESSAGE: 'A státusz nem módosítható.',
  },
  NOT_ACTIVE_STAND: {
    TITLE: 'Hiba',
    MESSAGE: 'A stand inaktív, ezért a kvíz nem indítható el.',
  },
  NOT_FOUND_DEVICE_TOKEN: {
    TITLE: 'Hiba',
    MESSAGE: 'Az eszköztoken nem található.',
  },
  NOT_FOUND_LOGO: {
    TITLE: 'Hiba',
    MESSAGE: 'A partner logója nem található.',
  },
  NOT_FOUND_NOTIFICATION: {
    TITLE: 'Hiba',
    MESSAGE: 'Az értesítés nem található.',
  },
  NOT_FOUND_PARTNER: {
    TITLE: 'Hiba',
    MESSAGE: 'A partner nem található.',
  },
  NOT_FOUND_PLAYER: {
    TITLE: 'Hiba',
    MESSAGE: 'A játékos nem található.',
  },
  NOT_FOUND_STAND: {
    TITLE: 'Hiba',
    MESSAGE: 'A kiállítói stand nem található.',
  },
  NOT_FOUND_WORKSHOP_APPLICATION: {
    TITLE: 'Hiba',
    MESSAGE: 'A workshop jelentkezés nem található.',
  },
  OUT_OF_RANGE_CORRECT_ANSWER_COUNT: {
    TITLE: 'Hiba',
    MESSAGE: 'Csak egy helyes válasz lehet.',
  },
  OUT_OF_RANGE_NOTIFICATION_CONTENT_LENGTH: {
    TITLE: 'Hiba',
    MESSAGE: 'Az értesítés leírásának hossza tartományon kívül esik.',
  },
  OUT_OF_RANGE_NOTIFICATION_TITLE_LENGTH: {
    TITLE: 'Hiba',
    MESSAGE: 'Az értesítés címének hossza tartományon kívül esik.',
  },
  OUT_OF_RANGE_NOTIFICATION_URL_LENGTH: {
    TITLE: 'Hiba',
    MESSAGE: 'Az értesítés URL-jének hossza tartományon kívül esik.',
  },
  QR_CODE_ALREADY_SCANNED: {
    TITLE: 'Hiba',
    MESSAGE: 'A QR-kódot már leolvasták.',
  },
  QUESTION_ALREADY_ANSWERED: {
    TITLE: 'Hiba',
    MESSAGE: 'Ez a kérdés már megválaszolásra került.',
  },
  REQUIRED_ANSWER: {
    TITLE: 'Hiba',
    MESSAGE: 'A válasz megadása kötelező.',
  },
  REQUIRED_ANSWERS: {
    TITLE: 'Hiba',
    MESSAGE: 'A válaszok megadása kötelező.',
  },
  REQUIRED_DEVICE_TOKEN: {
    TITLE: 'Hiba',
    MESSAGE: 'Az eszköztoken megadása kötelező.',
  },
  REQUIRED_EXHIBITION_STAND_NAME: {
    TITLE: 'Hiba',
    MESSAGE: 'A stand neve kötelező.',
  },
  REQUIRED_NOTIFICATION_CONTENT: {
    TITLE: 'Hiba',
    MESSAGE: 'Az értesítés leírása kötelező.',
  },
  REQUIRED_NOTIFICATION_TITLE: {
    TITLE: 'Hiba',
    MESSAGE: 'Az értesítés címe kötelező.',
  },
  REQUIRED_PARTNER_NAME: {
    TITLE: 'Hiba',
    MESSAGE: 'A partner neve kötelező.',
  },
  REQUIRED_PROGRAM_DESCRIPTION: {
    TITLE: 'Hiba',
    MESSAGE: 'A program leírása kötelező.',
  },
  REQUIRED_QUESTION: {
    TITLE: 'Hiba',
    MESSAGE: 'A kérdés megadása kötelező.',
  },
  TAKEN_ANSWER: {
    TITLE: 'Hiba',
    MESSAGE: 'A válasz már létezik.',
  },
  TAKEN_STAND_NAME: {
    TITLE: 'Hiba',
    MESSAGE: 'A stand neve már létezik.',
  },
  TOO_LONG_ANSWER: {
    TITLE: 'Hiba',
    MESSAGE: 'A válasz túl hosszú.',
  },
  TOO_LONG_DEVICE_TOKEN: {
    TITLE: 'Hiba',
    MESSAGE: 'Az eszköztoken túl hosszú.',
  },
  TOO_LONG_EXHIBITON_STAND_NAME: {
    TITLE: 'Hiba',
    MESSAGE: 'A stand neve túl hosszú.',
  },
  TOO_LONG_PARTNER_DESCRIPTION: {
    TITLE: 'Hiba',
    MESSAGE: 'A partner leírása túl hosszú.',
  },
  TOO_LONG_PARTNER_NAME: {
    TITLE: 'Hiba',
    MESSAGE: 'A partner neve túl hosszú.',
  },
  TOO_LONG_QUESTION: {
    TITLE: 'Hiba',
    MESSAGE: 'A kérdés túl hosszú.',
  },
  UNAVAILABLE_AUTH0_SERVICE: {
    TITLE: 'Hiba',
    MESSAGE: 'Átmeneti problémát észleltünk a szervereinkél, elnézését kérjük.',
  },
  UNPROCESSABLE_ANSWER: {
    TITLE: 'Hiba',
    MESSAGE: 'A válasz ehhez a standhoz nem feldolgozható.',
  },
  USER_ALREADY_EXISTS: {
    TITLE: 'Hiba',
    MESSAGE: 'Nem megfelelő felhasználói adatok.',
  },
};

export const handleIdentifiedError: HandleIdentifiedErrorFn = error => {
  if (error instanceof BackendErrorWithMessageError) {
    const { message, status, headers, response } = error;

    const { errors } = error.backendError;
    const errorName = errors[0].strId;
    const translation = translations[errorName];
    if (translation !== undefined) {
      return openOKDialog({
        title: { text: translation.TITLE, translate: false },
        message: { text: translation.MESSAGE, translate: false },
      }).pipe(map(() => new HandledErrorResponse(message, status, response, headers, error)));
    }
  }

  return of(error);
};
